(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordk-destaques-cores"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      raiz.querySelectorAll('[data-nk-carrossel]').forEach(function (sec) {
        var trilho = sec.querySelector('[data-nk-trilho]');
        var setas = sec.querySelectorAll('[data-nk-seta]');
        if (!trilho || sec.dataset.nkOk) return;
        sec.dataset.nkOk = '1';
        function atualizar() {
          var max = trilho.scrollWidth - trilho.clientWidth - 2;
          setas[0].disabled = trilho.scrollLeft <= 2;
          setas[1].disabled = trilho.scrollLeft >= max;
        }
        setas.forEach(function (b) {
          b.addEventListener('click', function () {
            var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            trilho.scrollBy({ left: Number(b.dataset.nkSeta) * trilho.clientWidth * 0.9, behavior: reduz ? 'auto' : 'smooth' });
          });
        });
        trilho.addEventListener('scroll', atualizar, { passive: true });
        window.addEventListener('resize', atualizar);
        atualizar();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); }); else iniciar(document);
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordk-recomendacoes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setas(sec) {
      var trilho = sec.querySelector('[data-nk-trilho]');
      var bts = sec.querySelectorAll('[data-nk-seta]');
      if (!trilho || bts.length < 2 || sec.dataset.nkSetas) return;
      sec.dataset.nkSetas = '1';
      function atualizar() {
        bts[0].disabled = trilho.scrollLeft <= 2;
        bts[1].disabled = trilho.scrollLeft >= trilho.scrollWidth - trilho.clientWidth - 2;
      }
      bts.forEach(function (b) {
        b.addEventListener('click', function () {
          var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          trilho.scrollBy({ left: Number(b.dataset.nkSeta) * trilho.clientWidth * 0.9, behavior: reduz ? 'auto' : 'smooth' });
        });
      });
      trilho.addEventListener('scroll', atualizar, { passive: true });
      sec._nkAtualizar = atualizar;
      atualizar();
    }
    function carregar(sec) {
      if (sec.dataset.nkRecOk) return;
      sec.dataset.nkRecOk = '1';
      setas(sec);
      var trilho = sec.querySelector('[data-nk-trilho]');
      var limite = parseInt(sec.dataset.limite, 10) || 8;
      fetch(sec.dataset.url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var lista = tmp.querySelector('[data-nk-rec-cards]');
          if (lista) Array.prototype.forEach.call(lista.children, function (li) {
            if (trilho.children.length < limite) trilho.appendChild(li.cloneNode(true));
          });
          if (trilho.children.length) sec.hidden = false;
          if (sec._nkAtualizar) sec._nkAtualizar();
        })
        .catch(function () {});
    }
    function iniciar(raiz) { raiz.querySelectorAll('[data-nk-rec]').forEach(carregar); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); }); else iniciar(document);
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
